import { IntlShape } from 'react-intl'
import * as yup from 'yup'
import { partnerContactSchema } from 'features/Partners/components/PartnerContactsCard/schema'
import { bankDataSchema } from 'features/Partners/components/PartnerBankDataCard/schema'
import { INewPartnerStep2 } from 'features/Partners/types'

export const schema = (
  intl: IntlShape,
  { isEditContacts = false, isEditBankData = false }
): yup.SchemaOf<INewPartnerStep2> => {
  return yup.object().shape({
    contacts: isEditContacts
      ? yup.array().of(partnerContactSchema.required(intl))
      : yup.array().of(partnerContactSchema.optional(intl)),
    bankData: isEditBankData ? bankDataSchema.required(intl) : bankDataSchema.optional(intl)
  })
}
